import { ImportTypeConfig } from '#/store/hooks/useForms/Import/types/ImportTypeConfig'

export const milk: ImportTypeConfig = {
  type: 'milk',
}
